import { SVGProps, Ref, forwardRef } from 'react';

export const LivejournalSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.441 1.9c-.924 0-1.802.192-2.604.54L4.397 1A6.58 6.58 0 0 0 1 4.413l1.44 1.44a6.5 6.5 0 0 0-.549 2.602 6.55 6.55 0 0 0 4.05 6.048 6.56 6.56 0 0 0 7.143-1.424A6.549 6.549 0 0 0 8.44 1.9m2.73 5.861L5.842 2.44a6.57 6.57 0 0 0-3.4 3.414l5.334 5.321a6.58 6.58 0 0 1 3.397-3.413m.377 1.816.004.003-.001-.004.517 2.498-2.487-.515a3.83 3.83 0 0 1 1.967-1.982"
            fill="currentColor"
        />
    </svg>
));
LivejournalSolidSize16Glyph.displayName = 'LivejournalSolidSize16Glyph';
